import { all, takeLatest, call, put } from '@redux-saga/core/effects';
import axios from 'axios';

import { requestLogin } from './login.actions';
import { getLoginRequest } from './login.endpoints';

import { addSystemNotice, addSpinner, removeSpinner } from '../../slices/system/system.slice';

import { ERROR } from '../../utils/constants';
import { getErrorMessage } from '../../utils/api-util';
import { saveToLocalStorage } from '../../utils/util';

export function* performLoginRequest({ payload }) {
  const { input, deleteAccount, onSuccess } = payload;

  try {
    yield put(addSpinner('Logging In'));

    const [endpoint, options] = getLoginRequest(input);

    const { data } = yield call(axios, endpoint, options);
    const { user } = data;

    if (!deleteAccount && user.role !== 'admin') {
      yield put(removeSpinner('Logging In'));
      yield put(
        addSystemNotice({
          type: ERROR,
          message:
            'You do not have the required permissions to access this application from your web browser.' +
            ' Please attempt to log in from the Mobile App instead.'
        })
      );
      return;
    }

    yield call(saveToLocalStorage, 'token', data.token);
    yield call(saveToLocalStorage, 'user', user.userExternalReference);

    if (onSuccess) {
      yield call(onSuccess);
    }

    yield put(removeSpinner('Logging In'));
  } catch (error) {
    const message = getErrorMessage(error);
    yield put(removeSpinner('Logging In'));
    yield put(addSystemNotice({ type: ERROR, message }));
  }
}

export function* watchForLoginRequest() {
  yield takeLatest(requestLogin.type, performLoginRequest);
}

export default function* loginSaga() {
  yield all([watchForLoginRequest()]);
}
